import React from 'react';
import SummaryCard from './SummaryCard';
import { formatCurrency } from '../utils/formatters';

function EmergencyPlanning({ data }) {
    return (
        <SummaryCard title="Emergency Planning">
            <div className="mb-3">
                <p className="content-text text-gray-600 mb-2">
                    Ideal Emergency fund is <strong>{data.ideal_months} months</strong> of expenses!
                </p>
                <p className="content-text text-gray-500 text-sm mb-3">In your case, the amount would be</p>
            </div>

            {/* Calculation Card */}
            <div className="border-2 border-gray-300 rounded-lg p-3 mb-3 bg-gray-50">
                <div className="flex items-center justify-center gap-2 overflow-x-auto">
                    <span className="content-text font-medium text-gray-700 text-sm sm:text-base">
                        {formatCurrency(data.monthly_expense)}
                    </span>
                    <span className="content-text font-medium text-gray-600 text-sm">×</span>
                    <span className="content-text font-medium text-gray-700 text-sm">
                        {data.ideal_months}
                    </span>
                    <span className="content-text font-medium text-gray-600 text-sm">=</span>
                    <span className="content-text font-bold text-gray-800 text-base sm:text-lg">
                        {formatCurrency(data.ideal_fund)}
                    </span>
                </div>
            </div>

            {/* Current Status */}
            <div className="grid grid-cols-2 gap-4 mb-3">
                <div>
                    <p className="content-text text-gray-500 text-sm mb-1">Currently Allotted</p>
                    <p className="content-text font-bold text-pink-600">{formatCurrency(data.current_buffer)}</p>
                </div>
                <div className="text-right">
                    <p className="content-text text-gray-500 text-sm mb-1">Pending Amount</p>
                    <p className="content-text font-bold text-gray-800">{formatCurrency(data.pending_amount)}</p>
                </div>
            </div>

            {/* Border separator */}
            <div className="border-b border-gray-300 my-3"></div>

            {/* Recommendation */}
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-3">
                <div className="flex items-center gap-2">
                    <span className="text-pink-500 text-lg">❤</span>
                    <p className="content-text font-medium text-gray-700 mb-0">
                        Consider prioritising allocation towards emergency fund
                    </p>
                </div>
            </div>

            {/* Info note */}
            <div className="flex items-start gap-2">
                <span className="text-blue-500 text-sm mt-0.5">ℹ️</span>
                <p className="content-text text-gray-500 text-sm">
                    Your expenses include all liabilities from Home loan to groceries, etc
                </p>
            </div>
        </SummaryCard>
    );
}

export default EmergencyPlanning;





// import React from 'react';

// function formatCurrency(amount) {
//     if (typeof amount !== 'number' || isNaN(amount)) return '₹ 0';
//     return '₹ ' + amount.toLocaleString();
// }

// function EmergencyPlanning({ data }) {
//     return (
//         <section className="mb-5 md:mb-8">
//             <div className="bg-white rounded-2xl p-6 shadow-md">
//                 <h3 className="text-gray-900 text-xl font-bold mb-2">Emergency Planning</h3>
//                 <div className="text-sm text-gray-700 mb-1">
//                     Ideal Emergency fund is <b>{data.ideal_months} months</b> of expenses!
//                 </div>
//                 <div className="text-xs text-gray-500 mb-3">In your case, the amount would be</div>
//                 <div className="flex items-center justify-center mb-4">
//                     <div className="border-2 border-gray-400 rounded-xl px-5 py-4 flex items-center gap-2 text-lg font-bold shadow bg-white min-w-[270px]">
//                         <span className="text-gray-700">{formatCurrency(data.monthly_expense)}</span>
//                         <span className="text-xl font-semibold">× {data.ideal_months}</span>
//                         <span className="text-2xl font-bold text-gray-900">= {formatCurrency(data.ideal_fund)}</span>
//                         <span className="ml-2 text-gray-400 cursor-pointer" title="Copy">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="9" y="9" width="13" height="13" rx="2" strokeWidth="2" /><rect x="3" y="3" width="13" height="13" rx="2" strokeWidth="2" /></svg>
//                         </span>
//                     </div>
//                 </div>
//                 <div className="flex justify-between items-center mb-2">
//                     <div className="flex flex-col items-start">
//                         <span className="text-xs text-gray-500">Currently Allotted</span>
//                         <span className="font-bold text-base text-pink-600">{formatCurrency(data.current_buffer)}</span>
//                     </div>
//                     <div className="flex flex-col items-end">
//                         <span className="text-xs text-gray-500">Pending Amount</span>
//                         <span className="font-bold text-base text-gray-900">{formatCurrency(data.pending_amount)}</span>
//                     </div>
//                 </div>
//                 <hr className="my-3 border-gray-200" />
//                 {/* <div className="mb-4">
//                     <div className="font-semibold text-base text-gray-900 mb-2">Products best for emergency fund</div>
//                     <div className="flex flex-col gap-2 text-sm">
//                         {data.bestProducts.map((prod, idx) => (
//                             <label key={prod} className="flex items-center gap-2">
//                                 <input type="radio" name="bestProduct" defaultChecked={idx === 0} disabled className="accent-purple-500" />
//                                 {prod}
//                             </label>
//                         ))}
//                     </div>
//                 </div> */}
//                 <div className="mb-4 p-3 rounded-xl bg-purple-50 flex items-center gap-2 shadow-sm">
//                     <span className="text-pink-500 text-lg">❤</span>
//                     <span className="text-sm font-semibold text-gray-700">Consider prioritising allocation towards emergency fund</span>
//                 </div>
//                 <div className="flex items-center gap-2 text-xs text-gray-500 mt-2">
//                     <span>ℹ️</span>
//                     <span>Your expenses include all liabilities from Home loan to groceries, etc</span>
//                 </div>
//             </div>
//         </section>
//     );
// }

// export default EmergencyPlanning;

